import React from 'react';
import './index.css';
import { withStyles} from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import Apis from '../../../../network/Apis';
// import IMEventEmitter, { IMEvent } from '../../../../net/IMEventEmitter';
import MSnackbar from '../../../view/MSnackbar';
import AppData from '../../../../model/AppData';
import ToName from '../../../../control/ToName';

const ICON_ZAN_1 = require("../../../../images/icons/hongse.png");
const ICON_ZAN_2 = require("../../../../images/icons/lanse.png");



//欢迎xxxx进入聊天室
class ZanPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            leftTotal: '50%',
            rightTotal: '50%',
            home_num: 0,
            guest_num: 0,
            type: 0
            // index: 0
        };
    }
    componentDidMount() {
        this.checkZan()
    }
    componentWillUnmount() {

 
    }

    toZan = async (type) => {

        const { groupId } = this.props.data
        console.log(AppData.me.free_id);
        if (!AppData.me.isLogin()|| AppData.me.free_id === 0) {
            ToName(this.props, '/login') 
            return;
        }
        let result = await Apis.get('app/hostZan', {
            free_fid: AppData.me.free_id,
            groupId: groupId,
            type
        })
        if (result.code == 200) { 
            this.setState({
                type: type,
            })
            if (type == 1) {
                let _num = this.state.home_num + 1;
                this.setState({
                    home_num: _num,

                })
            } else {
                let _num = this.state.guest_num + 1;
                this.setState({
                    guest_num: _num,

                })

            }
        }



        this.refs.toast.show(result.msg);

    }

    checkZan = async () => {
        const { groupId, free_id } = this.props.data
        let result = await Apis.get('app/checkHostZanInfo', {
            free_fid: AppData.me.free_id,
            groupId: groupId
        })
        if (result.code != 200) return

        // const homenum = result.data.home_num
        // const guestnum = result.data.guest_num

        let left = result.data.home_num;
        let right = result.data.guest_num;
        let total = left + right

        //左边的百分比
        let leftTotal = (Math.round(left / total * 100)).toString()
        let rightTotal = (Math.round(right / total * 100)).toString()
        let leftText = leftTotal + '%'
        let rightText = rightTotal + '%'


        this.setState({
            leftTotal: leftText,
            rightTotal: rightText,
            guest_num: result.data.guest_num,
            home_num: result.data.home_num,
            type: result.data.type,
        })


    }


    render() {
        const team = this.props.team;
        return (
            <>
                <div className="zanPage">
                    <img src={ICON_ZAN_2} onClick={() => this.toZan(1)} className='limg'></img>
                    <div className='centerBox'>
                        <div className='silbox'>
                            <div className='lefttame' style={{ width: this.state.leftTotal }}>{this.state.home_num}</div>
                            <div className='righttame' style={{ width: this.state.rightTotal }}>{this.state.guest_num}</div>
                        </div>
                        <div className='teamTextBox'>
                            <div className='left'>
                                <div className='teamtext'>{team[0]}</div>
                                {this.state.type == 1 &&
                                    <div className='zhichi'>支持</div>
                                }
                            </div>
                            <div className='right'>
                                {this.state.type == 2 &&
                                    <div className='zhichi'>
                                        支持
                                    </div>
                                }
                                <div className='teamtext' style={{marginRight:8}}>{team[1]}</div>
                            </div>
                        </div>
                    </div>
                    <img src={ICON_ZAN_1} onClick={() => this.toZan(2)} className='rimg'></img>
                    <MSnackbar ref='toast' />
                </div>
            </>
        )
    }
}


export default withRouter(withStyles((theme) => ({
    

}))(ZanPage));

// export default ZanPage